import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import Lien from './lien';
import ModalInner from "../../layoutItems/modalInner";

class LienPopup extends React.Component {
    render() {
        return (
            <ModalInner title={this.props.translate("Report.Detail")} close={this.props.close}>
                <table style={{ width: "100%" }} className="table table-report-section-2 liens-detail">
                    <thead>
                        <tr className="liens-head">
                            <th style={{ width: "15%" }}><Translate id="Report.Liens.FileMark" /></th>
                            <th style={{ width: "70%" }}><Translate id="Report.Liens.Type" /></th>
                            <th style={{ width: "15%" }}><Translate id="Report.Liens.Date" /></th>
                            <th style={{ width: "20px" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.data.map(lien => <Lien key={lien.lienId} lien={lien} />)
                        }
                    </tbody>
                </table>
            </ModalInner>
        )
    }
}

export default withLocalize(LienPopup);